import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const GroupedStackedBarChart = ({ data }) => {
    
    const series = [
        {
            name: "In Private",
            group: "in",
            data: new Array(new Date().getHours()).fill(0),
        },
        {
            name: "In Trucks",
            group: "in",
            data: new Array(new Date().getHours()).fill(0),
        },
        {
            name: "Out Trucks",
            group: "out",
            data: new Array(new Date().getHours()).fill(0),
        },
        {
            name: "Out Private",
            group: "out",
            data: new Array(new Date().getHours()).fill(0),
        },
    ];

    for (let i = 0; i < data.length; i++) {
                if (data[i].deviceId === "600a0c2a69e88a8e") {
                    series[0].data[parseInt(data[i].hour.split(":")[0])] = data[i].vehiclesCount;
                    series[1].data[parseInt(data[i].hour.split(":")[0])] = data[i].otherCount;
                } else {
                    series[3].data[parseInt(data[i].hour.split(":")[0])] = data[i].vehiclesCount;
                    series[2].data[parseInt(data[i].hour.split(":")[0])] = data[i].otherCount;
                }
    }

    const categoriesData = [];

    for (let i = 0; i <= new Date().getHours(); i++) {
        if (i<10) {
            categoriesData.push(`0${i}:00`);            
        } else {
            categoriesData.push(`${i}:00`);
        }
    }

    console.log(categoriesData);

    const options = {
        chart: {
            type: "bar",
            height: 350,
            stacked: true,
        },
        stroke: {
            width: 1,
            colors: ["#fff"],
        },
        dataLabels: {
            formatter: (val) => {
                return val;
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
            },
        },
        xaxis: {
            categories: categoriesData,
        },
        fill: {
            opacity: 1,
        },
        colors: ["#003fb185", "#00dfc9a6", "#8cb4fd8f", "#48fdeb9e"],
        yaxis: {
            labels: {
                formatter: (val) => {
                    return val;
                },
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
        },
        title: {
            text: "Road90",
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
        }
        
    };

    return (
        <div>
            <div id="chart">
                <ReactApexChart
                    options={options}
                    series={series}
                    type="bar"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default GroupedStackedBarChart;
